import React from 'react';
import { motion } from 'framer-motion';
import { AnimationStates } from 'core/constants/animation-states';

interface IFadeWrapper {
  children: any;
  className: string;
  animationState: string;
}

const FadeWrapper = ({ children, className, animationState }: IFadeWrapper) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: animationState === AnimationStates.EXITING ? 0 : 1 }}
      transition={{ duration: 0.2 }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default FadeWrapper;
